import * as styles from "./ColorPickerContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";
import { pointerAlignOffset } from "@frontend/utils/pointerAlign";

import { useColorPickerContext } from "./ColorPicker.context";
import type { ColorPickerContentProps } from "./ColorPicker.types";
import { ColorPickerArrow } from "./ColorPickerArrow";
import { ColorPickerBackdrop } from "./ColorPickerBackdrop";
import { ColorPickerPortal } from "./ColorPickerPortal";
import { ARROW_SIZES } from "./constants";

const GAP = 4;

export function ColorPickerContent({
  className,
  children,
  side = "bottom",
  sideOffset,
  align = "center",
  alignOffset,
  positionMethod,
  ...props
}: ColorPickerContentProps): JSX.Element {
  const { arrow, size, pointerOffsetRef } = useColorPickerContext();

  return (
    <ColorPickerPortal>
      <ColorPickerBackdrop />
      <BasePopover.Positioner
        data-slot="color-picker-positioner"
        side={side}
        sideOffset={sideOffset ?? (arrow ? ARROW_SIZES[size] : GAP)}
        align={align}
        alignOffset={alignOffset ?? pointerAlignOffset(pointerOffsetRef, arrow)}
        positionMethod={positionMethod}
        className={styles.positioner}
      >
        <BasePopover.Popup
          data-slot="color-picker-popup"
          className={clsx(styles.popup, className)}
          {...props}
        >
          {arrow && <ColorPickerArrow />}
          {children}
        </BasePopover.Popup>
      </BasePopover.Positioner>
    </ColorPickerPortal>
  );
}
